import { $, $$ } from 'utils/dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { fadeInFromBottom } from '../animations';
import { viewport } from '../getViewport';

export const storyHero = () => {
  const heroes = $$('.story-hero');

  if (heroes.length) {
    heroes.forEach(hero => {
      const heroText = $('.story-hero__text-inner', hero);

      const timeline = gsap.timeline();

      gsap.set(hero, {
        '--filter-value': viewport.isReduced ? '1' : '3',
      });

      timeline.to(
        hero,
        {
          '--filter-value': () => 1,
        },
        '<+=10%'
      );

      ScrollTrigger.create({
        animation: timeline,
        trigger: hero,
        start: () => 'top 95%',
        end: () => 'top 30%',
        toggleActions: 'play pause resume reset',
        scrub: 1,
      });

      if (heroText) {
        fadeInFromBottom([heroText]);
      }

      const videoButton = $('.story-hero__video-button', hero);
      const video = $('.story-hero__media video', hero);

      if (videoButton && video) {
        const playPauseVideo = () => {
          if (video.paused) {
            playVideo();
          } else {
            pauseVideo();
          }
        };

        const playVideo = () => {
          video.play();
          videoButton.classList.remove('is-paused');
        };

        const pauseVideo = () => {
          video.pause();
          videoButton.classList.add('is-paused');
        };

        videoButton.addEventListener('click', playPauseVideo);
      }
    });
  }
};
